import MainModel from "../../../components/Models/main-model";
import { brandPalette } from "../../../constants/brandPalette";
import {
  Box,
  FormLabel,
  Heading,
  Textarea,
  Button,
  VStack,
  HStack,
  Text,
} from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { closeRefuseHomeworkModel } from "../../../modules/admin-modules/models/Actions";
import { useState, useEffect } from "react";
import { deleteStuentHomeworkRequest } from "../../../modules/admin-modules/reports/Actions";
import { getAssistantsRequest } from "../../../modules/admin-modules/teachersAssistant/Actions";
import Select from "react-select";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
  adminSelectStyles,
} from "../../../components/Models/admin-modal-theme";
const HomeworkRefuseComment = ({ data, homeworkId }) => {
  const baseUrl = "https://asquera.com/asquera";

  const openHomeworkComment = useSelector((state) => state.model.isOpen32);
  const [comment, setComment] = useState("");
  const dispatch = useDispatch();
  const assistants = useSelector((state) => state.teacherassistants.assistants);
  const [assistant, setAssistant] = useState("");
  const [assistantComment, setAssistantComment] = useState("");
  const assistantsOptions = assistants?.data?.map((a) => {
    return { value: a.id, label: a.name, sign: a.school };
  });

  useEffect(() => {
    dispatch(getAssistantsRequest());
  }, []);

  const header = (
    <Box>
      <Heading textAlign="left" color={brandPalette.primary} fontSize="20px" fontWeight="900">
        Reject submission
      </Heading>
      <Text mt={1} fontSize="sm" fontWeight="700" color="rgba(91, 13, 22, 0.55)">
        Choose a template or write a custom reason.
      </Text>
    </Box>
  );

  const handelAddComment = async () => {
    await dispatch(deleteStuentHomeworkRequest({
      evaluation: comment,
      student_id: data?.student?.id,
      homework_id: data?.homework?.id,
      assistant_id: assistant,
      assistant_comment: assistantComment,
    }));
    dispatch(closeRefuseHomeworkModel());
  };

  const closeFunc = () => {
    dispatch(closeRefuseHomeworkModel());
    setComment("");
    setAssistant("");
    setAssistantComment("");
  };

  const setEvalation = (evaluation) => () => {
    setComment(evaluation);
    const el = document.getElementById("homework");
    if (el) el.value = evaluation;
  };

  return (
    <MainModel
      isLoading={false}
      header={header}
      closeFunc={closeFunc}
      openVar={openHomeworkComment}
      buttonTitle={"Save changes"}
      cancelTitle="Cancel"
      buttonFunc={handelAddComment}
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={adminModalBodyProps}
      footerProps={{
        borderTop: "1px solid rgba(214, 206, 192, 0.5)",
        py: 6,
      }}
    >
      <VStack align="stretch" spacing={5} dir="ltr">
        <HStack justify="space-between" flexWrap="wrap" spacing={3}>
          <Text fontSize="sm" fontWeight="800" color={brandPalette.primary}>
            Student: <Text as="span" fontWeight="900">{data?.student?.name || "N/A"}</Text>
          </Text>
          <Text fontSize="sm" fontWeight="800" color={brandPalette.primary}>
            Homework: <Text as="span" fontWeight="900">{data?.homework?.name || "N/A"}</Text>
          </Text>
          <Button
            as="a"
            href={`https://docs.google.com/gview?url=${baseUrl}${data?.file}`}
            target="_blank"
            size="sm"
            borderRadius="12px"
            bg="white"
            border="1px solid rgba(214, 206, 192, 0.85)"
            color={brandPalette.primary}
            fontWeight="800"
            _hover={{ bg: "rgba(255,255,255,0.75)" }}
          >
            Open file
          </Button>
        </HStack>

        <Box>
          <FormLabel fontWeight="800" color={brandPalette.primary}>
            Quick templates
          </FormLabel>
          <HStack w="100%" flexWrap="wrap" spacing={2}>
            <Button
              size="sm"
              borderRadius="12px"
              bg="rgba(255,255,255,0.72)"
              border="1px solid rgba(214, 206, 192, 0.85)"
              color={brandPalette.primary}
              fontWeight="800"
              _hover={{ bg: "white" }}
              onClick={setEvalation("Your homework was rejected due to missing steps. Please complete the steps and upload again.")}
            >
              Missing steps
            </Button>
            <Button
              size="sm"
              borderRadius="12px"
              bg="rgba(255,255,255,0.72)"
              border="1px solid rgba(214, 206, 192, 0.85)"
              color={brandPalette.primary}
              fontWeight="800"
              _hover={{ bg: "white" }}
              onClick={setEvalation("Your homework was rejected because there are many incorrect answers. Please review using the homework video and upload again.")}
            >
              Many wrong answers
            </Button>
            <Button
              size="sm"
              borderRadius="12px"
              bg="rgba(255,255,255,0.72)"
              border="1px solid rgba(214, 206, 192, 0.85)"
              color={brandPalette.primary}
              fontWeight="800"
              _hover={{ bg: "white" }}
              onClick={setEvalation("Your homework was rejected due to missing questions. Please complete the homework and upload again.")}
            >
              Incomplete answers
            </Button>
            <Button
              size="sm"
              borderRadius="12px"
              bg="rgba(255,255,255,0.72)"
              border="1px solid rgba(214, 206, 192, 0.85)"
              color={brandPalette.primary}
              fontWeight="800"
              _hover={{ bg: "white" }}
              onClick={setEvalation("Your homework was rejected because the uploaded PDF is not the correct homework. Please upload the correct file.")}
            >
              Wrong file
            </Button>
          </HStack>
        </Box>

        <Box w="100%">
          <FormLabel fontWeight="800" color={brandPalette.primary}>
            Rejection reason
          </FormLabel>
          <Textarea
            bg="rgba(255,255,255,0.72)"
            borderColor="rgba(214, 206, 192, 0.85)"
            borderRadius="14px"
            placeholder="Write the reason…"
            onChange={(e) => setComment(e.target.value)}
            name="homework"
            id="homework"
            _focus={{ borderColor: brandPalette.primary, boxShadow: "0 0 0 3px rgba(91, 13, 22, 0.12)" }}
          ></Textarea>
        </Box>

        <Box w="100%">
          <FormLabel fontWeight="800" color={brandPalette.primary}>
            Assistant
          </FormLabel>
          <Select
            styles={adminSelectStyles()}
            options={assistantsOptions}
            onChange={(e) => {
              setAssistant(e.value);
              const el = document.getElementById("homework");
              if (el) {
                el.value += "\n\n" + e.sign;
                setComment(el.value);
              }
            }}
            placeholder="Select assistant"
          />
        </Box>

        <Box w="100%">
          <FormLabel fontWeight="800" color={brandPalette.primary}>
            Assistant notes
          </FormLabel>
          <Textarea
            id="assistantComment"
            bg="rgba(255,255,255,0.72)"
            borderColor="rgba(214, 206, 192, 0.85)"
            borderRadius="14px"
            placeholder="Write assistant notes…"
            onChange={(e) => setAssistantComment(e.target.value)}
            name="homework"
            _focus={{ borderColor: brandPalette.primary, boxShadow: "0 0 0 3px rgba(91, 13, 22, 0.12)" }}
          ></Textarea>
        </Box>
      </VStack>
    </MainModel>
  );
};

export default HomeworkRefuseComment;
